import { connect } from 'react-redux';
import { getStep } from '../../../../../redux/selectors/ui/ui.selectors';
import { routesAffichees } from '../../../../../utils/function';
import { getRoutesByDevice } from '@amo/core/utils/getRoutesByDevice.js';
import NavBar from './NavBar';
import RouteStep from '../RouteStep';
import {postFill} from "formulaire-televente/src/redux/actions/app/fill/fill.actions.js";
import _ from "lodash";
import {getMaxStep} from "formulaire-televente/src/redux/selectors/ui/ui.selectors.js";
import {API_URL_WS_FORMULAIRE} from "@amo/core/constants/index.js";
import {getToken} from "formulaire-televente/src/redux/selectors/init/init.selectors.js";
import {getFormValues} from "redux-form";

const mapStateToProps = (state) => {
    return {
        routes: routesAffichees(getRoutesByDevice(getStep(state),RouteStep)),
        activeStep: getStep(state),
        maxStep: getMaxStep(state),
        query: `${API_URL_WS_FORMULAIRE}/fill/${getToken(state)}`,
        form: getFormValues('devis')(state),
    };
};

const mapDispatchToProps = {
    postFill
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { form, maxStep, query } = stateProps
    const { postFill } = dispatchProps

    return {
        ...ownProps, ...stateProps, ...dispatchProps,
        postFill: (slug) => postFill({step: _.find(RouteStep, ['slug', slug]).step, maxStep, form, query})
    }
}

const NavBarContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(NavBar);

export default NavBarContainer;
